<template>
    <div class="paddingSpace">
      <b-container>
        <b-row class="TitleArea">
            <b-col sm="12" lg="6">
                <h1 class="heading extraPad">Order of Merit</h1>
            </b-col>
            <b-col  sm="12" lg="6" class="above769">
              <div>
                <b-dropdown id="dropdown-1" :text="title" class="m-md-2">
                  <b-dropdown-item value="T1" title="Tier 1 Order of Merit" v-on:click="pickStat">Tier 1 Order of Merit</b-dropdown-item>
                  <b-dropdown-item value="T2" title="Tier 2 Order of Merit" v-on:click="pickStat">Tier 2 Order of Merit</b-dropdown-item>
                  <b-dropdown-item value="AL" title="Amateur League Order of Merit" v-on:click="pickStat">Amateur League Order of Merit</b-dropdown-item>
                  <!-- <b-dropdown-item value="pam" title="Pro-Ams Order of Merit" v-on:click="pickStat">Pro-Ams Order Of Merit</b-dropdown-item> -->
                </b-dropdown>
              </div>
            </b-col>
        </b-row>
        <div v-if="noDataMessage" class="noOOM">
          <h2 class="noPresent">{{ noDataMessage }}</h2>
        </div>
        <div v-else>
          <div class="above769">
            <vueper-slides
              class="no-shadow"
              :visible-slides="3"
              :gap="2"
              :bullets="false"
              :autoplay="true"
              :duration="3000"
              :slide-ratio="1 / 4"
              :infinite="true"
              :dragging-distance="70">
              <template #arrow-left>
                <img class="arrowSize leftArrow" src="https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/left-arrow.png">
              </template>

              <template #arrow-right>
                <img class="arrowSize rightArrow" src="https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/right-arrow.png">
              </template>
              <vueper-slide v-for="(slide, i) in slides" :key="'fivedex' + i">

                <template #content>

                <!-- Our system image -->
                <template v-if="slide.image === 'Y'">

                  <div
                    class="oomImage"
                    :style="{
                      backgroundImage: `url(${slide.cachedImageUrl})`
                    }"
                  >
                    <div class="arrowbox">
                      <span
                        class="posSlide"
                        :style="color"
                      >
                        {{ slide.pos }}
                      </span>
                    </div>
                  </div>

                </template>


                <!-- SmugMug image -->
                <template v-else-if="hasSmugMugImage(slide)">

                  <b-link
                    :href="slide.stat_rounds_played_images[0].smug_web_url"
                    target="_blank"
                  >
                    <div
                      class="oomImage"
                      :style="{
                        backgroundImage: `url(${slide.cachedImageUrl})`
                      }"
                    >
                      <div class="arrowbox">
                        <span
                          class="posSlide"
                          :style="color"
                        >
                          {{ slide.pos }}
                        </span>
                      </div>
                    </div>
                  </b-link>

                </template>


                <!-- No image -->
                <template v-else>

                  <div
                    class="oomImage"
                    :style="{
                      backgroundImage: `url(${dummyOOMImage})`
                    }"
                  >
                    <div class="arrowbox">
                      <span
                        class="posSlide"
                        :style="color"
                      >
                        {{ slide.pos }}
                      </span>
                    </div>
                  </div>

                </template>
                  <div class="oomSliderPad">
                    <div class="posCenter">
                    </div>
                    <b-row>
                      <b-col lg="8">
                        <p class="slideName">
                        {{slide.forename}}
                        {{slide.surname}}
                        </p>
                      </b-col>
                      <b-col lg="4">
                        <span class="oomSliderDetails">
                          <img
                          :class="flag"
                          :src="(config.VUE_APP_FLAG_URL + slide.nationality) | lowercase"
                          />
                        </span>
                      </b-col>
                    </b-row>
                    <hr class="lineBreakLine">
                    <b-row>
                      <b-col>
                        <span class="oomSliderTitle">Wins</span>
                      </b-col>
                      <b-col>
                        <span class="oomSliderDetails">{{slide.wins}}</span>
                      </b-col>
                    </b-row>
                    <hr class="lineBreakLine">
                    <b-row>
                      <b-col>
                        <span class="oomSliderTitle">Tournament</span>
                      </b-col>
                      <b-col>
                        <span class="oomSliderDetails">{{slide.tournaments_played}}</span>
                      </b-col>
                    </b-row>
                    <hr class="lineBreakLine">
                    <template v-if="oomData.oom_type == 'points'">
                      <b-row>
                        <b-col>
                          <span class="oomSliderTitle">Points</span>
                        </b-col>
                        <b-col>
                          <span class="oomSliderDetails">{{slide.oom_value}}</span>
                        </b-col>
                      </b-row>
                    </template>
                    <template v-else>
                      <b-row>
                        <b-col>
                          <span class="oomSliderTitle">Prize Money</span>
                        </b-col>
                        <b-col>
                          <span class="oomSliderDetails">{{slide.winnings}}</span>
                        </b-col>
                      </b-row>
                    </template>
                  </div>
                </template>
              </vueper-slide>
            </vueper-slides>
          </div>
          <div class="below769">
            <vueper-slides
              :touchable="true"
              class="no-shadow"
              :visible-slides="1"
              :gap="2"
              :bullets="false"
              :autoplay="true"
              :duration="3000"
              :slide-ratio="1 / 4"
              :infinite="true"
              :dragging-distance="70">
              <vueper-slide v-for="(slide, i) in slides" :key="'sixdex' + i">
                <template #content>
                  <!-- Local image exists -->
                  <template v-if="slide.image == 'Y'">
                    <div
                      class="oomImage"
                      :style="{
                        backgroundImage: 'url(https://tms-images.ams3.cdn.digitaloceanspaces.com/cpt/media/photos/' + slide.playerno + '.jpg)'
                      }"
                    ></div>
                  </template>

                  <!-- SmugMug images exist -->
                  <template v-else-if="slide.stat_rounds_played_images && slide.stat_rounds_played_images.length">
                    <b-link :href="slide.stat_rounds_played_images[0].smug_web_url" target="_blank">
                      <div
                        class="oomImage"
                        :style="{
                          backgroundImage: 'url(' + slide.stat_rounds_played_images[0].smug_thumbnail + ')'
                        }"
                      >
                      <div class="arrowbox">
                        <span class="posSlide" :style="color">{{ slide.pos }}</span>
                      </div>
                      </div>
                    </b-link>
                  </template>

                  <!-- Fallback -->
                  <template v-else>
                    <div
                      class="oomImage"
                      :style="{
                        backgroundImage: 'url(https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/dummy-image.jpg)'
                      }"
                    >
                      <div class="arrowbox">
                        <span class="posSlide" :style="color">{{ slide.pos }}</span>
                      </div>
                    </div>
                  </template>
                  <div class="oomSliderPad">
                    <div class="posCenter">
                    </div>
                    <b-row>
                      <b-col lg="8">
                        <p class="slideName">
                        {{slide.forename}}
                        {{slide.surname}}
                        </p>
                      </b-col>
                      <b-col lg="4">
                        <span class="oomSliderDetails">
                          <img
                          :class="flag"
                          :src="(config.VUE_APP_FLAG_URL + slide.nationality) | lowercase"
                          />
                        </span>
                      </b-col>
                    </b-row>
                    <hr class="lineBreakLine">
                    <b-row>
                      <b-col>
                        <span class="oomSliderTitle">Tournament</span>
                      </b-col>
                      <b-col>
                        <span class="oomSliderDetails">{{slide.tournaments_played}}</span>
                      </b-col>
                    </b-row>
                    <hr class="lineBreakLine">
                    <b-row>
                      <b-col>
                        <span class="oomSliderTitle">Wins</span>
                      </b-col>
                      <b-col>
                        <span class="oomSliderDetails">{{slide.wins}}</span>
                      </b-col>
                    </b-row>
                    <hr class="lineBreakLine">
                    <template v-if="oomData.oom_type == 'points'">
                      <b-row>
                        <b-col>
                          <span class="oomSliderTitle">Points</span>
                        </b-col>
                        <b-col>
                          <span class="oomSliderDetails">{{slide.oom_value}}</span>
                        </b-col>
                      </b-row>
                    </template>
                    <template v-else>
                      <b-row>
                        <b-col>
                          <span class="oomSliderTitle">Prize Money</span>
                        </b-col>
                        <b-col>
                          <span class="oomSliderDetails">{{slide.winnings}}</span>
                        </b-col>
                      </b-row>
                    </template>
                  </div>
                </template>
              </vueper-slide>
            </vueper-slides>
            <!-- <div class="mobFulRank">
                <b-link to="/stats" class="allNewsLink">
                    <button class="Allbuttons">
                        See Full Rankings
                    </button>
                </b-link>
            </div> -->
          </div>
        </div>
        <!-- <carousel-3d :autoplay="true" :autoplay-timeout="5000" :display="5" :controls-visible="true" :disable3d="true" :space="380">
            <slide v-for="(slide, i) in slides" :index="i" :key="'sevendex' + i" >
              <template v-if="slide.image == 'Y'">
                <div class="oomImage" v-bind:style="{ 'background-image': 'url(' + 'https://tms-images.ams3.cdn.digitaloceanspaces.com/cpt/media/photos/' + slide.playerno +'.jpg' + ')' }">
                </div>
              </template>
              <template v-else>
                <div class="oomImage" v-bind:style="{ 'background-image': 'url(' + 'https://ams3.digitaloceanspaces.com/ocs-sport/tartanprotour/2025/02/dummy-image.jpg' + ')' }">
                </div>
              </template>
              <div class="oomSliderPad">
                <div class="posCenter">
                    <span class="posPosition">{{slide.pos}}</span>
                </div>
                  <p class="slideName">
                  {{slide.forename}}
                  <br>
                  {{slide.surname}}
                  </p>
                <b-row> 
                  <b-col>
                    <span class="oomSliderTitle">Nationality</span>
                  </b-col>
                  <b-col>
                    <span class="oomSliderDetails">
                      <img
                      :class="flag"
                      :src="(config.VUE_APP_FLAG_URL + slide.nationality) | lowercase"
                      />
                    </span>
                  </b-col>
                </b-row>
                <hr class="lineBreakLine">
                <b-row>
                  <b-col>
                    <span class="oomSliderTitle">Points</span>
                  </b-col>
                  <b-col>
                    <span class="oomSliderDetails">{{slide.oom_value}}</span>
                  </b-col>
                </b-row>
                <hr class="lineBreakLine">
                <b-row>
                  <b-col>
                    <span class="oomSliderTitle">Tournament</span>
                  </b-col>
                  <b-col>
                    <span class="oomSliderDetails">{{slide.tournaments_played}}</span>
                  </b-col>
                </b-row>
              </div>
            </slide>
        </carousel-3d> -->
      </b-container>
    </div>
</template>
<script>
import apiCall from "@/services/api.js";
import {
  fetchAndCacheImage,
  getCachedImage,
  createCachedImageUrl
} from "@/services/imageCache";
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import axios from 'axios';
// import { Carousel3d, Slide } from 'vue-carousel-3d';
export default {
  name: "OOM Slider Homepage",
  props: ["Year", 'config'],
    components: {
        // Carousel3d,
        // Slide
        VueperSlides, VueperSlide
    },
  data() {
    return {
      cachedImages: {},
      slides: 10,
      fields: [
        { key: "pos", label: "Pos" , class: "posnum"},
        { key: "name", label: "Name" },
        { key: "nationality", label: "Nat" },
        { key: "oom_value", label: "Points" },
        { key: "tournaments_played", label: "Tourns" }
      ],
      currentOom: [],
      previousOom: [],
      year: parseInt(this.Year) - 1,
      flag: "flag",
      pPage:4,
      oomData: [],
      imageAlbumList: [],
      fullAlbumList: [],
      playerImages: [],
      title: 'Tier 1 Order of Merit',
      // title: 'Tier 1 Order of Merit',
      statTour: '',
      color:'',
      noDataMessage:"",
      dummyOOMImage:
        'https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/dummy-image.jpg'
      };
  },
  methods:{
    /**
     * Does this player have a SmugMug image?
     */
    async loadCachedImageImmediately(player) {
      if (!player || !player.playerno) {
        return false;
      }

      const cacheKey = `cpt-oom-${player.playerno}`;

      try {
        const cached = await getCachedImage(cacheKey);

        if (cached && cached.blob) {
          const objectUrl = createCachedImageUrl(cached);

          this.$set(
            this.cachedImages,
            cacheKey,
            objectUrl
          );

          this.$set(
            player,
            'cachedImageUrl',
            objectUrl
          );

          return true;
        }
      } catch (error) {
        console.warn(
          `Could not load cached image for ${player.playerno}`,
          error
        );
      }

      return false;
    },
    hasSmugMugImage(slide) {
      return !!(
        slide &&
        slide.stat_rounds_played_images &&
        slide.stat_rounds_played_images.length &&
        slide.stat_rounds_played_images[0] &&
        slide.stat_rounds_played_images[0].smug_thumbnail
      );
    },


    /**
     * Get the correct Order of Merit image.
     *
     * Priority:
     *
     * 1. Our system image
     * 2. SmugMug image
     * 3. Dummy image
     */
    getOOMImage(slide) {

      // OUR SYSTEM IMAGE
      if (slide && slide.image === 'Y') {
        return `https://tms-images.ams3.cdn.digitaloceanspaces.com/cpt/media/photos/${slide.playerno}.jpg`;
      }


      // SMUGMUG IMAGE

      if (this.hasSmugMugImage(slide)) {
        return slide.stat_rounds_played_images[0].smug_thumbnail;
      }


      // DUMMY IMAGE

      return this.dummyOOMImage;
    },
    async getCachedOOMImage(slide) {
      if (!slide) {
        return this.dummyOOMImage;
      }

      // -----------------------------------------
      // OUR SYSTEM IMAGE
      // -----------------------------------------
      if (slide.image === 'Y') {
        return `https://tms-images.ams3.cdn.digitaloceanspaces.com/cpt/media/photos/${slide.playerno}.jpg`;
      }

      // -----------------------------------------
      // SMUGMUG IMAGE
      // -----------------------------------------
      if (this.hasSmugMugImage(slide)) {
        const smugUrl =
          slide.stat_rounds_played_images[0].smug_thumbnail;

        // IMPORTANT:
        // Use the player number as the main cache key.
        // We don't want to need SmugMug before checking the cache.
        const cacheKey = `cpt-oom-${slide.playerno}`;

        // Already loaded during this page session
        if (this.cachedImages[cacheKey]) {
          return this.cachedImages[cacheKey];
        }

        const cached = await getCachedImage(cacheKey);

        if (cached && cached.blob) {
          const objectUrl = createCachedImageUrl(cached);

          this.$set(this.cachedImages, cacheKey, objectUrl);

          return objectUrl;
        }

        // Not cached - download and save it
        const imageUrl = await fetchAndCacheImage(
          cacheKey,
          smugUrl
        );

        this.$set(this.cachedImages, cacheKey, imageUrl);

        return imageUrl;
      }

      // -----------------------------------------
      // DUMMY IMAGE
      // -----------------------------------------
      return this.dummyOOMImage;
    },
    async cacheOOMImages() {
      if (!this.slides || !this.slides.length) {
        return;
      }

      // Only cache the first 10 currently displayed players
      const players = this.slides.slice(0, 10);

      await Promise.all(
        players.map(async (slide) => {
          try {
            const imageUrl = await this.getCachedOOMImage(slide);

            this.$set(
              slide,
              'cachedImageUrl',
              imageUrl
            );
          } catch (error) {
            console.warn(
              `Could not cache image for player ${slide.playerno}`,
              error
            );

            this.$set(
              slide,
              'cachedImageUrl',
              this.getOOMImage(slide)
            );
          }
        })
      );
    },
    upDown(){
      if (this.pPage === 4)
      this.pPage = 10
      else if (this.pPage === 10)
      this.pPage = 4
    },
    pickStat: function(event) {
      var stat = event.target.getAttribute("title");
      this.title = stat;
      var tour = event.target.getAttribute("value");
      console.log('tour ' + tour)
      this.statTour = tour;
      console.log('this.statTour ' + this.statTour)
      this.colourStat(tour);
      let cacheTour = ""

      if (tour == 'T1') {
        cacheTour = 'cpt'
      } else if (tour == 'T2') {
        cacheTour = 'cp2'
      } else if (tour == 'AL') {
        cacheTour = 'cp3'
      }
      axios
        .get(
          "https://api.euro.ocs-software.com/cpt/cache/" +
            cacheTour +
            "/" +
            this.Year +
            "/" +
            this.Year +
            "-ooms-oom-" +
            tour +
            ".json?randomadd=" +
            new Date().getTime()
        )
       .then(async (response) => {
          this.oomData = response.data;

          if (!this.oomData || Object.keys(this.oomData).length === 0) {
            this.noDataMessage = "No data available";

            return axios.get(
              "https://api.euro.ocs-software.com/cpt/cache/" +
                cacheTour +
                "/" +
                this.year + // ⚠️ check case here
                "/" +
                this.year +
                "-ooms-oom-" +
                tour +
                ".json?randomadd=" +
                new Date().getTime()
            );
          } else {

            this.slides = response.data.oom.oom_entry.slice(0, 10);

            // =====================================================
            // STEP 1: LOAD CACHED IMAGES FIRST
            // =====================================================

            await Promise.all(
              this.slides.map(async (player) => {
                await this.loadCachedImageImmediately(player);
              })
            );

            // =====================================================
            // STEP 2: NOW GET SMUGMUG DATA
            // =====================================================

            await Promise.all(
              this.slides.map(async (player) => {
                try {
                  const albumRes = await axios.get(
                    'https://wp-cpt.ocs-software.com/wp-content/themes/wp-bootstrap-starter/OCS/xsreq.php?url=' +
                    encodeURIComponent(
                      btoa(
                        'https://api.smugmug.com/api/v2/folder/user/andycrook/Clutch-Pro-Tour/Profile/Scorecards/' +
                        player.playerno +
                        '!albumlist?APIKey=GjCjfVHhkdhHHtzDqngmMk47vwQ4Qkf2&_accept=application/json'
                      )
                    )
                  );

                  const albums =
                    albumRes.data.Response.AlbumList || [];

                  let images = [];

                  for (const album of albums) {

                    const imgRes = await axios.get(
                      'https://wp-cpt.ocs-software.com/wp-content/themes/wp-bootstrap-starter/OCS/xsreq.php?url=' +
                      encodeURIComponent(
                        btoa(
                          'https://api.smugmug.com' +
                          album.Uri +
                          '!images?APIKey=GjCjfVHhkdhHHtzDqngmMk47vwQ4Qkf2&_accept=application/json'
                        )
                      )
                    );

                    const albumImages =
                      imgRes.data.Response.AlbumImage || [];

                    albumImages.forEach(img => {
                      images.push({
                        smug_thumbnail: img.ArchivedUri,
                        smug_web_url: img.WebUri
                      });
                    });
                  }

                  // Attach SmugMug images
                  player.stat_rounds_played_images = images;

                  // =================================================
                  // ONLY DOWNLOAD IF WE DON'T ALREADY HAVE A CACHE
                  // =================================================

                  if (!player.cachedImageUrl && images.length) {
                    player.cachedImageUrl =
                      await this.getCachedOOMImage(player);
                  }

                } catch (err) {

                  console.log(
                    `Error for player ${player.playerno}`,
                    err
                  );

                  player.stat_rounds_played_images = [];
                }
              })
            );

            this.noDataMessage = "";
          }
        })
        .then((fallbackResponse) => {
          if (fallbackResponse) {
            const data = fallbackResponse.data;

            if (data && Object.keys(data).length > 0) {
              this.slides = data.oom.oom_entry.slice(0, 10);
              localStorage.setItem("oom", JSON.stringify(this.slides));
              this.oomData = data;
              this.noDataMessage = "";
            }
          }
        })
        .catch((error) => {
          console.log("error in axios call", error);
          this.noDataMessage = "No Order of Mertit Data Available";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    colourStat: function(tour) {
      if (tour == 'T1') {
        this.color = 'color: #bceff0'
      } else if (tour == 'T2') {
        this.color = 'color: #bde9d8'
      } else if (tour == 'AL') {
        this.color = 'color: #dfc3c2'
      } else if (tour == 'pam') {
        this.color = 'color: #fff'
      } else if (tour == 'qsc') {
        this.color = 'color: #ededc3'
      }
    },
  },
  computed:{
    ooms:function (){
      if (this.currentOom !== null)
      return this.currentOom
      else return this.previousOom
    },
    // colourTour: function() {
    //   var color = '';
    //   if (this.statTour == 'cpt') {
    //     color = 'color: #bceff0'
    //   } else if (this.tournID == 'cp2') {
    //     color = 'color: #1FFFA5'
    //   } else if (this.tournID == 'cp3') {
    //     color = 'color: #dfc3c2'
    //   } else if (this.tournID == 'pam') {
    //     color = 'color: #fff'
    //   } else if (this.tournID == 'qsc') {
    //     color = 'color: #1FFFA5'
    //   }
    //   return color
    // },
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }

      return value.toLowerCase() + ".svg";
    }
  },
async mounted() {
  try {
    const stat = "-ooms-oom-" + "T1";
    const tour = "cpt";

    // =====================================================
    // STEP 1
    // Get the OOM data
    // =====================================================
    let response = await apiCall.stat(this.Year, stat, tour);

    this.oomData = response.data;

    // =====================================================
    // STEP 2
    // Fallback if current year has no data
    // =====================================================
    if (!this.oomData || Object.keys(this.oomData).length === 0) {
      this.noDataMessage = "No Order of Mertit Data Available";

      const fallback = await apiCall.stat(this.year, stat);

      if (
        fallback.data &&
        Object.keys(fallback.data).length > 0
      ) {
        this.oomData = fallback.data;

        this.slides = fallback.data.oom.oom_entry.slice(0, 10);

        localStorage.setItem(
          "oom",
          JSON.stringify(this.slides)
        );

        this.noDataMessage = "";
      }
    } else {
      // =====================================================
      // STEP 3
      // We have our players immediately
      // =====================================================
      this.slides = response.data.oom.oom_entry.slice(0, 10);

      localStorage.setItem(
        "oom",
        JSON.stringify(this.slides)
      );

      // =====================================================
      // STEP 4
      // IMPORTANT:
      // Load IndexedDB images BEFORE touching SmugMug
      // =====================================================
      await Promise.all(
        this.slides.map(async (player) => {
          await this.loadCachedImageImmediately(player);
        })
      );

      // =====================================================
      // STEP 5
      // Vue now has the cached images.
      //
      // Let Vue render them before we start the
      // slower SmugMug requests.
      // =====================================================
      await this.$nextTick();

      // =====================================================
      // STEP 6
      // NOW get SmugMug information
      //
      // This happens AFTER the cached images have already
      // been assigned to the players.
      // =====================================================
      await Promise.all(
        this.slides.map(async (player) => {
          try {
            const albumRes = await axios.get(
              "https://wp-cpt.ocs-software.com/wp-content/themes/wp-bootstrap-starter/OCS/xsreq.php?url=" +
                encodeURIComponent(
                  btoa(
                    "https://api.smugmug.com/api/v2/folder/user/andycrook/Clutch-Pro-Tour/Profile/Scorecards/" +
                      player.playerno +
                      "!albumlist?APIKey=GjCjfVHhkdhHHtzDqngmMk47vwQ4Qkf2&_accept=application/json"
                  )
                )
            );

            const albums =
              albumRes.data.Response.AlbumList || [];

            let images = [];

            for (const album of albums) {
              const imgRes = await axios.get(
                "https://wp-cpt.ocs-software.com/wp-content/themes/wp-bootstrap-starter/OCS/xsreq.php?url=" +
                  encodeURIComponent(
                    btoa(
                      "https://api.smugmug.com" +
                        album.Uri +
                        "!images?APIKey=GjCjfVHhkdhHHtzDqngmMk47vwQ4Qkf2&_accept=application/json"
                    )
                  )
              );

              const albumImages =
                imgRes.data.Response.AlbumImage || [];

              albumImages.forEach((img) => {
                images.push({
                  smug_thumbnail: img.ArchivedUri,
                  smug_web_url: img.WebUri
                });
              });
            }

            // =================================================
            // Attach SmugMug information to player
            // =================================================
            this.$set(
              player,
              "stat_rounds_played_images",
              images
            );

            // =================================================
            // IMPORTANT
            //
            // If IndexedDB already supplied the image,
            // DO NOT download it again.
            //
            // Only cache/download when there isn't already
            // a cached image.
            // =================================================
            if (
              !player.cachedImageUrl &&
              images.length
            ) {
              const imageUrl =
                await this.getCachedOOMImage(player);

              this.$set(
                player,
                "cachedImageUrl",
                imageUrl
              );
            }

          } catch (err) {
            console.log(
              `Error for player ${player.playerno}`,
              err
            );

            this.$set(
              player,
              "stat_rounds_played_images",
              []
            );
          }
        })
      );

      this.noDataMessage = "";
    }

    // =====================================================
    // STEP 7
    // Finished
    // =====================================================
    this.loading = false;

  } catch (error) {
    console.log("error in OOM mounted()");
    console.log(error);

    this.noDataMessage =
      "No Order of Mertit Data Available";

    this.loading = false;
  }
}
};
</script>

<style scoped>
h2.noPresent {
  padding-bottom: 0 !important;
  text-align: center;
  padding-top: 2.4em;
  font-size: 32px !important;
  color: #081C3F;
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
}
.noOOM {
  background-color: #F8F8F8;
  height: 200px;
}
span.posSlide {
  color: #00FFFE;
  font-size: 33px;
  font-weight: bold;
  position: relative;
  top: 22px;
  left: 22px;
}
.arrowbox {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/OoM_Triangle.png');
  background-repeat: no-repeat;
  height: 89px;
  position: relative;
  top: 162px;
}
::v-deep .flag {
  width: 30px;
  box-shadow: 0 0 0px #555!important;
  position: relative;
  top: -11px;
}
::v-deep button#dropdown-1__BV_toggle_ {
  width: 100%;
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
  width: 424px;
  height: 52px;
  border-radius: 26px;
}
::v-deep .dropdown-toggle::after {
  float: right;
  position: relative;
  top: 10px;
}
::v-deep .btn {
  text-align: left;
  font-size: 18px;
  font-weight: bold;
}
::v-deep .btn-secondary {
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
  border-radius: 0px;
}
::v-deep .btn-secondary:hover {
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
}
::v-deep .btn-secondary:active {
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
}
::v-deep .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #081C3F;
  background-color: transparent;
  border-color: #081C3F;
  width: 100%;
}
::v-deep .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 18px;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}
div#dropdown-1 {
  width: 424px;
  height: 52px;
  text-align: left;
  float: right;
  border-radius: 0px;
}
a.allNewsLink {
  text-decoration: none!important;
}
.mobFulRank {
  position: relative;
  top: -18px;
}
::v-deep button.vueperslides__arrow.vueperslides__arrow--prev {
  left: -5.5em;
}
::v-deep button.vueperslides__arrow.vueperslides__arrow--next {
  right: -5.5em;
}
.arrowSize {
  width: 80px;
}
img.arrowSize.leftArrow {
}
img.arrowSize.rightArrow {
}
.vueperslides--rtl .vueperslides__arrows--outside .vueperslides__arrow--prev, .vueperslides__arrows--outside .vueperslides__arrow--next {
  left: auto;
  right: -4.5em!important;
}
.vueperslides--rtl .vueperslides__arrows--outside .vueperslides__arrow--next, .vueperslides__arrows--outside .vueperslides__arrow--prev {
  right: auto;
  left: -4.5em!important;
}
::v-deep .vueperslides__parallax-wrapper {
  padding-bottom: 45%!important;
}
::v-deep .carousel-3d-slide {
  border-radius: 6px!important;
}
a.playerProfile:hover {
  text-decoration: none;
}
::v-deep a.prev {
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/11/Left-Arrow.png);
  height: 66px !important;
  width: 70px !important;
  z-index: 9999;
  /* position: relative; */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  top: 14px;
  left: -6px;
}
::v-deep a.next {
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/11/Right-Arrow.png);
  height: 66px !important;
  width: 70px !important;
  z-index: 9999;
  /* position: relative; */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  top: 14px;
  right: -5px;
}
::v-deep a.next > span{
  display: none;
}
::v-deep a.prev > span{
  display: none;
}
.lineBreakLine {
  margin-top: 10px;
}
.oomSliderPad {
  padding-left: 40px;
  padding-right: 40px;
  background-color: #fff;
  height: 400px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
span.oomSliderDetails {
  color: #081C3F;
  font-size: 20px;
  font-weight: 600;
  float: right;
}
span.oomSliderTitle {
  color: #081C3F;
  font-size: 16px;
  font-weight: 600;
}
.posPosition {
  position: relative;
  top: 30px;
}
.posCenter {
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  width: 90px;
  margin: auto;
  /* background-color: #081C3F; */
  background: url(https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/Ellipse-3-2.png);
  background-repeat: no-repeat;
  height: 90px;
  border-radius: 50px;
  position: relative;
  top: -1.8em;
  background-size: contain;
}
.slideName {
  color: #081C3F;
  font-size: 30px;
  text-align: left;
  font-weight: bold;
  /* margin-top: -0.8em; */
  margin-top: -18px;
  margin-bottom: 30px;
}
.oomImage {
  background-repeat: no-repeat;
  background-size: cover;
  height: 250px;
  /* background-position: center; */
  background-position: center;
}
::v-deep .carousel-3d-container {
  height: 625px !important;
}
::v-deep .carousel-3d-slide {
  position: absolute;
  opacity: 0;
  visibility: hidden;
  overflow: hidden;
  top: 0;
  border-radius: 50px;
  /* border-color: #000; */
  /* border-color: rgba(0, 0, 0, .4); */
  border-style: solid;
  background-size: cover;
  background-color: #fff;
  display: block;
  margin: 0;
  box-sizing: border-box;
  text-align: left;
  height: 625px !important;
  border: 1px solid #e9e9e9;
}
.TitleArea {
  padding-bottom: 30px;
}
.paddingSpace {
  padding: 50px;
}
.Allbuttons {
  float: right;
  width: 244px;
  height: 50px;
  background: transparent;
  color: #081C3F;
  /* font-weight: 500; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 30px;
  border: 1px solid #081C3F;
  font-size: 16px;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
.Allbuttons:hover {
  float: right;
  width: 244px;
  height: 50px;
  background: #081C3F;
  color: #fff;
  /* font-weight: 500; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border-radius: 30px;
  border: 1px solid #E8E8E8;
  transform: translateY(-10px);
}
h1.heading.extraPad {
  /* padding: 20px; */
}
.heading{
  /* font-weight: 600; */
  font-size: 36px;
  color: #081C3F;
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
}
::v-deep tbody {
  font-size: 1rem;
}
a {
  color: #337ab7!important;
  background-color: transparent;
  font-weight: 500;
}
a:hover{
  text-decoration: underline;
}
::v-deep td.posnum {
  padding: 5px;
  background-color: #081C3F;
  color: #ffffff;
  padding-top: 4px;
  padding-bottom: 4px;
  display: block;
  max-width: 58px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2px;
  margin-bottom: 0px;
  text-align: center;
}
::v-deep thead {
  color: white; 
}

::v-deep th {
  width: 15%;
  text-align: left;
  background-color: #081C3F!important;
  font-weight: 400;
}

::v-deep td {
  text-align: left;
  padding-top: 6px!important;
  padding-bottom: 6px!important;
  font-size: 1rem;
}
::v-deep th:first-child{
  text-align: center;
}
.flag {
  width: 30px;
  box-shadow: 0 0 3px #555;
}
::v-deep tr:nth-child(odd) {
  background-color: #dfe1e6;
}
.table{
      margin-bottom: 0;
}
.more{
  background-color: #dfe1e6;
  text-align: center;
}
::v-deep td{
  border-top: 0!important;
}
.flex{
  display: inline-flex;
}
.moreBtn{
  color: #337ab7 !important;
  font-size: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  background: #dfe1e6!important;
  border: none!important;
  box-shadow: none!important;
  padding: 0.375rem 0.175rem;
}
.fullList{
  width: auto!important;
}
.fullList>a{
  color: #337ab7 !important;
  font-size: 20px;
  font-weight: 400;
  text-decoration: none;
}
li {
  list-style: none;
}
.black{
  color: black;
  margin-left: -10px;
}
::v-deep .vueperslide {
  border: 1px solid #E0E0E0;
}

@media only screen and (max-width: 990px) {
  .carousel-3d-slide.current {
    width: 100%!important;
  }
  .Allbuttons {
    float: none;
    width: 244px;
    height: 50px;
    background: transparent;
    color: #081C3F;
    /* font-weight: 500; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 30px;
    border: 1px solid #081C3F;
    display: block;
    margin: auto;
    margin-top: 30px;
    transition: all 0.4s ease;
    /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
    transition: all 350ms cubic-bezier(.37, 0, .63, 1);
  }
  .Allbuttons:hover {
    float: none;
    width: 244px;
    height: 50px;
    background: #081C3F;
    color: #fff;
    /* font-weight: 500; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 30px;
    border: 1px solid #E8E8E8;
    transform: translateY(-10px);
  }
  .heading {
    /* font-weight: 600; */
    font-size: 36px;
    color: #081C3F;
    text-align: center;
    padding-top: 30px;
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
  }
   .paddingSpace {
    padding: 15px;    
  }
  ::v-deep .carousel-3d-slider {
    width: auto!important;
  }
}
@media only screen and (max-width: 768px) {

  ::v-deep th {
    font-size: 13px !important;
  }
  ::v-deep td {
    font-size: 13px !important;
  }
  .fullList>a{
    font-size: 12px!important;
    padding-left: 0.7rem;
  }.moreBtn{
    font-size: 12px!important;
  }
  ::v-deep th:nth-child(3){
    display: none;
  }
  ::v-deep td:nth-child(3){
    display: none;
  }
}
@media only screen and (min-width: 769px) {
  .below769 {
    display: none;
  }
}
@media only screen and (max-width: 769px) {
  .above769 {
    display: none;
  }
  ::v-deep .vueperslides__parallax-wrapper
  {
      padding-bottom: 214% !important;
  }
}
@media only screen and (max-width: 510px) {
  ::v-deep .vueperslides__parallax-wrapper
  {
      padding-bottom: 183% !important;
  }
}
@media only screen and (max-width: 410px) {
  ::v-deep .vueperslides__parallax-wrapper
  {
      padding-bottom: 214% !important;
  }
}
</style>
